module["exports"] = [];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/it/name/suffix.js
// module id = 1315
// module chunks = 0